<main id="main-content" class="container" *ngIf="cookiesText">
    <app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>
    
    <div class="container">
        <div class="row">
            <div class="col-12" [innerHTML]="cookiesText"></div>
        </div>
    </div>
</main>